import { render } from "./recent-video.vue?vue&type=template&id=5d25bdba"
import script from "./recent-video.vue?vue&type=script&lang=js"
export * from "./recent-video.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__